import React, {Component, useDebugValue, useEffect, useSyncExternalStore} from 'react';
import { useState } from "react";
import { FaEdit } from "react-icons/fa";
import { Button, Alert, Modal, Col, FormControl } from 'react-bootstrap';
import UserDataService from './services/user.serviceaux.js';
import OrganigramaAreasDataService from './services/organigramaarea.service.js';
import CompetenciaDataService from './services/competencia.service.js';
import { logout } from './actions/auth.js';
import { Form, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Controller, useForm } from "react-hook-form";
import {dtForInputDate} from './AuxiliaryFunctions.js'

function AsignarUsuario(props) { 
  const dispatch = useDispatch();

  const { control, handleSubmit, formState: { errors },} = useForm({
    defaultValues: {
      userId: props.user?props.user.id:0
      /*
      primernombre: props.edituser.primernombre,      
      segundonombre: props.edituser.segundonombre,
      primerapellido: props.edituser.primerapellido,
      segundoapellido: props.edituser.segundoapellido,
      fechadenacimiento: dtForInputDate(props.edituser.fechadenacimiento),
      telefonomovil: props.edituser.telefonomovil,
      email: props.edituser.email,
      habilitado: props.edituser.habilitado,
      curp: props.edituser.curp,
      */
    },
  });  

  const [lgShow, setLgShow] = useState(false);
  const [Errmessage, setErrmessage] = useState("");
  const [Showerror, setShowerror] = useState("");
  const [Sucmessage, setSuccmessage] = useState("");
  const [Showsuccess, setShowsuccess] = useState("");
  const [Submitted, setSubmitted] = useState(false);
  const [mode, setMode] = useState(props.mode);

  const [userId, setUserId] = useState(props.usuario?props.usuario.id:0);    
  const [usuarios, setusuarios] = useState([]);  
  const [selectedUser, setSelectedUser] = useState({});
  
  const { user } = useSelector(state => state.auth);

  const onChangeidusuario = (e) => {  
    //console.log(e.target.value);
    const userId = e.target.value;
    setUserId(userId);
    console.log(errors);
  };
  
  const handleClose = () => {
    window.location.reload();
    setLgShow(false);
  }
  
  const handleShow = () => {
    console.log(props);
    setUserId(props.user?props.user.id:0);
    setSelectedUser(usuarios.find(usuario => usuario.userid === parseInt(props.user.id)) || {});    

    //UserDataService.getAllWithConfirmed(props.organigrama?props.organigrama.id:0,0)
    //UserDataService.getUserByDescr('','primerapellido','ASC')
    UserDataService.getListaCompleta(props.organigrama.competencia[0].id, 1, "id", "ASC")
    .then(response => {
        console.log(response.data);
        setSuccmessage('');
        setErrmessage('');
        setShowerror(false);
        setShowsuccess(false);      
        setusuarios(response.data);
        //setnombrecompetencia(response.data.nombrecompetencia);
        //setdescripcioncompetencia(response.data.descripcioncompetencia);
        //setfechainicio(response.data.fechainicio);
        //setfechafin(response.data.fechafin);
        setLgShow(true);        
      })      
    .catch(e => {
      console.log(e);
    });  

  }

  let handleValidations = () => {
    /*
    console.log(userRoles.length);
    if (username.length ==0 || userRoles.length == 0) {      
      setErrmessage('Campos requeridos.');
      setShowerror(true);
      return;
    }
    if (email) {
      if (!/\S+@\S+\.\S+/.test(email)) {
        setErrmessage('El correo no es válido.');
        setShowerror(true);      
        return;
      }
    }
    */
    saveAsignacionUsuario();
  } 

  let saveAsignacionUsuario = (e)  =>{     
    var data = {
      userId: parseInt(userId), //parseInt(e.userId),
    }
    
    console.log(data);
    
    OrganigramaAreasDataService.update(props.id, data)
    .then(response => {
      console.log(response);
      setSubmitted(true);
      setSuccmessage('Se asignó el juez al área N1.');
      setShowsuccess(true);
      setErrmessage('');
      setShowerror(false);        
      handleClose();
    })
    .catch(e => {
      console.log(e);
      setErrmessage(e.response?e.response.data.message:e.message);
      setShowerror(true);      
      setSuccmessage('');
      setShowsuccess(false);            
    })   
  }


  useEffect(() => {
    console.log(selectedUser);
    setSelectedUser(usuarios.find(usuario => usuario.id === parseInt(userId)) || {});
  }, [userId]);

    return (
      <>
        <Button variant={props.user?"link":"primary"} onClick={handleShow} style={{width:"100%"}}>
          {props.user?
            (props.user.primerapellido + ' ' + (props.user.segundoapellido?props.user.segundoapellido:"")).trim() 
            + ", " 
            + (props.user.primernombre + ' ' + (props.user.segundonombre?props.user.segundonombre:"")).trim()
          :
          "Asignar"
          }
        </Button>      
        <Modal
          size="lg"
          show={lgShow}
          onHide={() => {handleClose();setLgShow(false)}}
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              {'Asignar juez'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <Form noValidate onSubmit={handleSubmit(saveAsignacionUsuario)}>
              <Row className='mt-2'>
                <Col className='col-md-3' md={6}>
                  <Form.Label>{props.posicion?"Nombre posición":"Nombre área"}</Form.Label>
                  <FormControl style={{maxWidth:"300px"}} type="text" name="nombrearean1" id="nombrearean1" disabled defaultValue={props.posicion?props.area.nombreposicion:props.area.nombrearea}></FormControl>
                </Col>
              </Row>                
              <Row className='mt-2'>
                <Col className='col-md-3' md={6}>
                  <Form.Label>Asignar juez</Form.Label>                
                    <Form.Select
                      onChange={onChangeidusuario}
                      className="mt-2"
                      type="select"
                      //defaultValue={userId}
                    >
                      <option key={0} value={null}>{"Seleccionar"}</option>
                      {
                        usuarios.map((row,index) => {
                          var conf = " \u2b55";
                          if (row.sum_no_null_confirmacion_activa > 0) {
                            conf = ' \u2705'; // " (confirmó disponibilidad)";
                          }                             
                          var assigned = " \u2705";
                          
                          if (row.count_no_null_compid > 0) {
                            assigned = ' \u2b55'; // " (no ha sido asignado a esta competencia)";
                          } 
                          
                          return (
                            <option 
                              key={index} 
                              value={row.userid}
                              selected={parseInt(row.userid) === parseInt(userId)}
                            >
                              
                              {
                              conf + assigned + " " +                                 
                              (row.primernombre + ' ' + (row.segundonombre?row.segundonombre:"")).trim()       
                              + " " +                                                             
                              (row.primerapellido + ' ' + (row.segundoapellido?row.segundoapellido:"")).trim() 
                              }
                            </option>
                          )
                        })
                      }
                    </Form.Select>

                    {/*
                    <Controller
                        name="userId"
                        control={control}
                        onChange={onChangeidusuario}
                        //defaultValue={usuarioId}
                        rules={{ required: true }}
                        render={({ field }) => (
                            <Form.Select
                            {...field}
                              //onSelect={(e) => {setSelectedUser(e.target.value)}}
                              className="mt-2"
                              type="select"
                              //placeholder="Nombre competencia"
                              isInvalid={errors.userId}
                              //defaultValue={props.user?props.user.id:0}
                              defaultValue={userId}
                            >
                              <option key={0} value={null}>{"Seleccionar"}</option>
                              {
                                usuarios.map((row,index) => {
                                  var conf = "";
                                  if (row.disponibilidad.length > 0 && row.disponibilidad[0].confirmacion_activa === 1) {
                                    conf = " (confirmó disponibilidad)";
                                  }                                  
                                  return (
                                    <option 
                                      key={index} 
                                      value={row.id}
                                    >
                                      {(row.primerapellido + ' ' + (row.segundoapellido?row.segundoapellido:"")).trim() 
                                      + ", " 
                                      + (row.primernombre + ' ' + (row.segundonombre?row.segundonombre:"")).trim()                                      
                                      + conf
                                      }
                                    </option>
                                  )
                                })
                              }
                            </Form.Select>
                        )}
                    />
                    {errors.userId && (
                        <Form.Control.Feedback type="invalid">
                          Se requiere el usuario.
                        </Form.Control.Feedback>
                    )}
                    */}
                </Col>                 
              </Row>
              <hr />
              {/**
              {(userId) &&
                <Row className='mt-2'>
                  <h6>
                    {(selectedUser.primerapellido + ' ' + (selectedUser.segundoapellido?selectedUser.segundoapellido:"")).trim() 
                    + ", " 
                    + (selectedUser.primernombre + ' ' + (selectedUser.segundonombre?selectedUser.segundonombre:"")).trim()                                      
                    }
                  </h6>
                  <label>
                    {selectedUser.arean1}
                  </label>
                </Row>
              }
              */}
              <hr />
              <div className="d-flex justify-content-start flex-wrap">      
         
                <button className="btn btn-secondary btn-block">
                  Guardar y cerrar
                </button>            
              </div> 

            </Form>
              {Showerror && (
                <Alert variant="danger" onClose={() => setShowerror(false)} dismissible>
                  <Alert.Heading>Error</Alert.Heading>
                  <p>{Errmessage}</p>
                </Alert>      
              )}
              {Showsuccess && (
                <Alert variant="success" onClose={() => setShowsuccess(false)} dismissible>
                  <Alert.Heading>Hecho</Alert.Heading>
                  <p>{Sucmessage}</p>
                </Alert>      
              )}     
          </Modal.Body>
        </Modal>
      </>
    );
  }

  
  export default AsignarUsuario;